import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import Sortable from 'sortablejs'
import IframeReloader from "./images_field/iframe_reloader"

export default class extends Controller {
  static targets = ["sortableContainer", "imageRow"]

  static values = {
    updateUrl: String,
    recordType: String,
    recordId: String,
    fieldName: String
  }

  connect() {
    this.iframeReloader = new IframeReloader(this)
  }

  sortableContainerTargetConnected() {
    this.initSortable()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initSortable() {
    this.sortable = new Sortable(this.sortableContainerTarget, {
      animation: 150,
      handle: '.drag-handle',
      onEnd: this.handleSortEnd.bind(this)
    })
  }

  async handleSortEnd(event) {
    if (event.oldIndex === event.newIndex) return

    try {
      await this.updatePositionsOnBackend()
      this.updatePositionNumbers()
      this.showSuccess()
    } catch (error) {
      console.error('Failed to update positions:', error)
      this.showError()
      this.revertSort(event)
    }
  }

  async updatePositionsOnBackend() {
    const positions = this.collectCurrentPositions()

    const data = {
      positions: positions,
      record_type: this.recordTypeValue,
      record_id: this.recordIdValue,
      field_name: this.fieldNameValue
    }

    const response = await patch('/madmin/attachments/sort', {
      body: JSON.stringify(data),
      contentType: "application/json"
    })

    if (response.ok) {
      return response.json
    } else {
      throw new Error(`Update failed: ${response.statusText}`)
    }
  }

  collectCurrentPositions() {
    const positions = {}

    this.imageRowTargets.forEach((row, index) => {
      const attachmentId = row.dataset.attachmentId
      if (attachmentId) {
        positions[attachmentId] = index + 1
      }
    })

    return positions
  }

  updatePositionNumbers() {
    this.imageRowTargets.forEach((row, index) => {
      const positionSpan = row.querySelector('.position-number')
      if (positionSpan) {
        positionSpan.textContent = index + 1
      }
    })
  }

  revertSort(event) {
    if (event.oldIndex < event.newIndex) {
      event.to.insertBefore(event.item, event.to.children[event.oldIndex])
    } else {
      event.to.insertBefore(event.item, event.to.children[event.oldIndex + 1])
    }
    this.updatePositionNumbers()
  }

  showSuccess() {
    this.showStatus('Reihenfolge aktualisiert', 'success')
    this.iframeReloader.reloadPreviewIframe()
  }

  showError() {
    this.showStatus('Reihenfolge konnte nicht aktualisiert werden', 'error')
  }

  showStatus(message, type) {
    const statusElement = this.element.querySelector('.sort-status')
    if (!statusElement) return

    statusElement.textContent = message

    const baseClasses = 'sort-status text-sm font-medium px-2 py-1 rounded border'
    if (type === 'success') {
      statusElement.className = `${baseClasses} text-green-700 bg-green-50 border-green-200`
    } else if (type === 'error') {
      statusElement.className = `${baseClasses} text-red-700 bg-red-50 border-red-200`
    }


    statusElement.classList.remove('hidden')

    setTimeout(() => {
      statusElement.classList.add('hidden')
    }, 1000)
  }

  addImageRow() {
    if (this.sortable) {
      this.sortable.destroy()
      this.initSortable()
    }
  }

  removeImageRow(attachmentId) {
    const row = this.imageRowTargets.find(r => r.dataset.attachmentId === attachmentId)
    if (row) {
      row.remove()
      this.updatePositionNumbers()
    }
  }
}